import graphqlClient from '@/graphql/graphql-client';
import { organizationIdForQuery, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  ContactssDocument,
  type ContactssQuery,
  type ContactssQueryVariables,
} from '@/graphql/generated/graphql';

export type ContactItem = NonNullable<
  NonNullable<ContactssQuery['getContactss']>['items'][number]
>;

export const useGetContacts = (
  params?: ListQueryVariables<Record<string, unknown>>,
  options?: { enabled?: boolean }
) => {
  const { where, paging } = toListQueryVariables(params);
  const variables: ContactssQueryVariables = {
    organizationId: organizationIdForQuery(where),
    pageNo: paging?.pageNo ?? 1,
    pageSize: paging?.pageSize ?? 10,
  };

  return useQuery({
    queryKey: ['contacts', variables],
    queryFn: () => graphqlClient.request(ContactssDocument, variables),
    enabled: options?.enabled ?? true,
  });
};

export const GET_CONTACTS_QUERY = ContactssDocument;
